<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs3 text-left>
            <span class="mainHeader">Profile</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <div class="cover-photo">
              <img
                class="background-image"
                src="./../../assets/img2.jpg"
              />
              <div class="profile-picture-container">
                <img
                  class="profile-picture"
                  src="./../../assets/icons/man.jpg"
                />
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap px-4 pt-10 justify-center>
          <v-flex xs8>
            <v-layout wrap>
              <v-flex xs10 class="mainHeader2"
                >{{ userData.firstname }} {{ userData.lastname }}</v-flex
              >
              <v-flex xs2> Edit<v-icon style="cursor:pointer" @click="calledit(userData)">mdi-pen</v-icon></v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-layout wrap py-2>
              <v-flex xs12 class="tst1" text-left>Role</v-flex>
              <v-flex xs12 class="subhead3" text-left>
                <span  v-if="userData.mainRole"
                  style="
                    
                    font-size: 14px;
                    color: grey;
                  "  class="text-truncate"
                >
                 {{ userData.mainRole.roles }}</span
                ><br/>
                <span  v-if="userData.mainRole.roles =='ConstituencyPresident' && userData.assemblyConstituencyId"
                  style="
                    
                    font-size: 14px;
                    color: grey;
                  "  class="text-truncate"
                >
                 {{ userData.assemblyConstituencyId.name }}</span
                >
              </v-flex>
            </v-layout>
            <v-layout wrap py-2>
              <v-flex xs12 class="tst1" text-left>Contact</v-flex>
              <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                userData.phone
              }}</v-flex>
            </v-layout>
            <v-layout wrap py-2>
              <v-flex xs12 class="tst1" text-left>Email</v-flex>
              <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                userData.email
              }}</v-flex>
            </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>DOB</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    formatDate(userData.dob)
                  }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left
                    >Age</v-flex
                  >
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.age
                  }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left
                    >Gender</v-flex
                  >
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.gender
                  }}</v-flex>
                </v-layout>
</v-flex>
            </v-layout>
           
            <v-layout wrap py-2>
              <v-flex xs12>
                <v-divider style="border-color:grey; !important"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout wrap py-2>
              <v-flex class="subhead3" text-left>Address</v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left> Address :</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{ userData.address }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Locality</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{ userData.locality }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>City</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.city
                  }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left
                    >District  & Pincode</v-flex
                  >
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.district
                  }} , {{ userData.pincode }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>State</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.state
                  }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Country</v-flex>
                  <v-flex xs12 class="subhead3" text-left  style="font-size: 14px;color: grey;">{{
                    userData.country
                  }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap py-2>
              <v-flex xs12>
                <v-divider style="border-color:grey; !important"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout wrap py-2>
              <v-flex class="subhead3" text-left>Other Details</v-flex>
            </v-layout>
            
            <v-layout wrap>
              <v-flex xs6>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Religion</v-flex>
                  <v-flex xs12 class="subhead3" text-left style="font-size: 14px;color: grey;">{{
                    userData.religion
                  }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Caste</v-flex>
                  <v-flex xs12 class="subhead3" text-left style="font-size: 14px;color: grey;">{{
                    userData.caste
                  }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Highest Education</v-flex>
                  <v-flex xs12 class="subhead3" text-left style="font-size: 14px;color: grey;">{{
                    userData.education
                  }}</v-flex>
                </v-layout>
                <v-layout wrap py-2>
                  <v-flex xs12 class="tst1" text-left>Profession</v-flex>
                  <v-flex xs12 class="subhead3" text-left style="font-size: 14px;color: grey;">{{
                    userData.profession
                  }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      
        <v-dialog width="800px" v-model="dialogedit">
            <v-form v-model="addcat2" ref="addcat2" @submit.prevent>
              <v-card tile width="800px" class="px-4 py-4 rounded-lg">
                <v-layout wrap justify-center>
                  <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Profile</span></v-flex>
                  <v-flex xs1 text-right>
                    <v-icon
                      @click="(dialogedit = false)"
                      color="#182444"
                      >mdi-close-box</v-icon
                    ></v-flex
                  >
                  <v-flex xs8 text-center py-4 >
                <v-divider></v-divider>
              </v-flex>
                </v-layout>
                <v-layout wrap pb-4>
                <!-- <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Election Type</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="electionList"
                        v-model="editItem.electionType"
                        label="Select Election Type"
                        item-text="name"
                        item-value="_id"
                        @input="electionType2(editItem.electionType)"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Constituency</span>
                    </v-flex>
                    <v-flex xs12>
                      <!-- <v-text-field
                        type="text"
                        label="Constituency"
                        v-model="editItem.assemblyConstituencyId"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field> -->
                      <v-autocomplete
                        :items="constituencyList"
                        v-model="editItem.assemblyConstituencyId"
                        label="Select Constituency"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Party</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="partyList"
                        v-model="editItem.mainPartyId"
                        label="Select Party"
                        item-text="name"
                        item-value="_id"
                        outlined
                        @input="chngParty(editItem.mainPartyId)"
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Sub-Party</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="subpartyList2"
                        v-model="editItem.subPartyId"
                        label="Select Sub-Party"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Personal Details</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="editItem.firstname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="editItem.lastname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">DOB</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="editItem.dob"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editItem.dob"
                    label="DOB"
                    background-color="white"
                    outlined color="#50659f"
                    readonly
                    hide-details
                    clearable
          dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editItem.dob"
                  no-title
                  scrollable
                  @change="$refs.menu3.save(editItem.dob)"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- </v-layout>
                <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Age</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Enter Age"
                        v-model="editItem.age"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="editItem.email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="editItem.phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Caste</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Caste"
                        v-model="editItem.caste"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Religion</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter Religion"
                        v-model="editItem.religion"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="editItem.gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Higher Education</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Higher Education"
                        v-model="editItem.education"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Address</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <!-- <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">City</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter City"
                        v-model="editItem.city"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Locality </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter Locality"
                        v-model="editItem.locality"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Address</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter  Address"
                        v-model="editItem.address"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Pincode</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="number"
                        label="Enter Pincode"
                        v-model="editItem.pincode"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">District</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter District"
                        v-model="editItem.district"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">State</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter State"
                        v-model="editItem.state"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Country</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter Country"
                        v-model="editItem.country"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
                <v-layout wrap pb-4 justify-end>
                  <v-spacer></v-spacer>
                  <v-flex xs3 text-right>
                    <v-layout wrap px-4 justify-end fill-height>
                      <v-flex xs12 text-center align-self-end class="buttons1">
                        <v-btn
                          type="submit"
                          color="#182444"
                          dark
                          block
                          @click="editCandidate()"
                          ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 2000,
      deletedialog: false,
      DeleteId: null,
      editItem: {},
      showSnackBar: false,
      menu3:false,
      subpartyList2:[],
      partyList:[],
      electionList:[],
      ServerError: false,
      appLoading: false,
      userList: [],
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      gender: "",
      dob: "",
      age: "",
      caste: "",
      religion: "",
      financialStatus: "",
      profession:"",
      twitter: "",
      instagram: "",
      facebook: "",
      genderList: ["Male", "Female", "Other"],
      financialList: ["Upper Class", "Middle Class", "Lower Class"],
      viewDetails: false,
      constituencyList: [],
      userDetails: [],
      page: 1,
      menu2: false,
      addcat2: false,
      currentPage: 1,
      addUser: false,
      dialogedit: false,
      boothFilter: "",
      //   curItem: {},
      msg: null,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
    };
  },

  computed: {
    userData() {
      return this.$store.state.userData;
    },
    // editItem() {
    //   return this.$store.state.userData;
    // },
  },
  mounted() {
    this.getData();
    this.getParty();
    this.getConstituency();
    if (this.$route.query.id) {
      this.boothFilter = this.$route.query.id;
      this.Newbooth = this.$route.query.id;
    } else {
      this.boothFilter = "";
    }
    // this.getBooth();
  },
  watch: {
    'editItem.dob': {
      handler(newDob) {
        if (newDob) {
          const dob = new Date(newDob);
          const today = new Date();
          const age = today.getFullYear() - dob.getFullYear();
          const monthDiff = today.getMonth() - dob.getMonth();

          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            this.editItem.age = age - 1;
          } else {
            this.editItem.age = age;
          }
          console.log("age==",this.editItem.age)
          if (this.editItem.age < 18) {
            this.msg="Age cannot be less than 18"
            this.showsnackbar = true;
          } else {
            this.showsnackbar = false;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    calledit(item){
      console.log("A")
       this.editItem = item;
       this.getSubParty2(item.mainPartyId._id);
      this.dialogedit = true;
      console.log("B")

    },
    getSubParty2(id) {
      console.log("werty")
      // this.appLoading = true;
      axios({
        url: "/sub/politicalparty/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          mainPartyId: id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subpartyList2 = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    editCandidate() {
      axios({
        url: "/user/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          firstname: this.editItem.firstname,
          lastname: this.editItem.lastname,
          country: this.editItem.country,
          state: this.editItem.state,
          district: this.editItem.district,
          pincode: this.editItem.pincode,
          address: this.editItem.address,
          // locality: this.editItem.locality,
          // city: this.editItem.city,
          phone: this.editItem.phone,
          email: this.editItem.email,
          dob: this.editItem.dob,
          age: this.editItem.age,
          profession: this.editItem.profession,
          caste: this.editItem.caste,
          religion: this.editItem.religion,
          gender: this.editItem.gender,
          education: this.editItem.education,
          // electionType: this.editItem.electionType,
          mainRole: this.mainRole2,
          mainPartyId:this.editItem.mainPartyId,
          subPartyId: this.editItem.subPartyId,
          constituency: this.editItem.constituency,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.dialogedit = false;
          location.reload();
          } else {
            this.showSnackBar = true;
          this.msg = response.data.msg;
          }
         
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    // electionType2(newVal) {
    //   if (newVal) {
    //     const selectedObject = this.electionList.find(
    //       (election) => election._id === newVal
    //     );

    //     if (selectedObject) {
    //       const selectedName = selectedObject.name;
    // this.checkRole2(selectedName);

    //     }
    //   }

    // },
    // checkRole2(item) {
    //   console.log("selectedName=", item);
    //   if (item == "State Legislative Assembly") {
    //     this.mainRole2 = "MLA";
    //   } else if (item == "LokSabha Election") {
    //     this.mainRole2 = "MP";
    //   } else if (item == "Dist.Panchayat Election") {
    //     this.mainRole2 = "District Member";
    //   } else if (item == "Block Panchayat Election") {
    //     this.mainRole2 = "Block Member";
    //   } else if (item == "GramaPanchayat Election") {
    //     this.mainRole2 = "Panchayat Member";
    //   }
    //   console.log("mainRole2=", this.mainRole2);
    //   // this.editCandidate();
    // },
    getData() {
      this.appLoading = true;
      axios({
        url: "/electiontype/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.electionList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getParty() {
      // this.appLoading = true;
      axios({
        url: "/main/politicalparty/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          // role: "MP",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.partyList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        //   this.getSubParty();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      //  +
      // " , " +
      // hours +
      // ":" +
      // minutes +
      // " " +
      // ampm;

      return strTime;
    },
      getConstituency() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/constituency/assembly/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.constituencyList = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.cover-photo {
  position: relative;
  width: 100%;
  height: 300px;
}

.background-image {
  width: 100%;
  height: 100%;
}

.profile-picture-container {
  position: absolute;
  width: 150px;
  height: 150px;
  left: 158px;
  top: 210px;
  border-radius: 50%;
  overflow: hidden;
}

.profile-picture {
  width: 100%;
  height: 100%;
}
</style>
